import { containerItems } from './shared';

export const row = {
  title: 'Row',
  ...containerItems,
  className: 'page-builder-large-stack',
  styles: {
    ...containerItems.styles,
    display: 'flex',
  },
  editableStyles: [
    ...containerItems.editableStyles,
  ],
};
